import {
  IntlProvider,
  LocalizationProvider,
  load,
  loadMessages,
} from "@progress/kendo-react-intl";
import { setScriptKey } from "@progress/kendo-licensing";
import kendoLicense from "../kendo-ui-license.txt?raw";
import React from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/vendors/fontawesome-free/css/all.min.css";
// Kendo CSS statik import kaldırıldı — applyKendoTheme() ile dinamik inject edilir
import "./index.css";
import {
  applyKendoTheme,
  DEFAULT_DARK_THEME,
  DEFAULT_LIGHT_THEME,
} from "./config/kendoThemes";

// İlk render flash'ını önlemek için tema hemen inject edilir
const savedKendoTheme = localStorage.getItem("kendoTheme");
const savedMode = localStorage.getItem("theme") ?? "dark";
applyKendoTheme(
  savedKendoTheme ??
    (savedMode === "dark" ? DEFAULT_DARK_THEME : DEFAULT_LIGHT_THEME),
);

import axios from "axios";

import currencyData from "cldr-core/supplemental/currencyData.json";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import weekData from "cldr-core/supplemental/weekData.json";
import timeZoneNamesEn from "cldr-dates-full/main/en/timeZoneNames.json";
import caGregorian from "cldr-dates-full/main/tr/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/tr/dateFields.json";
import timeZoneNamesTr from "cldr-dates-full/main/tr/timeZoneNames.json";
import currenciesEn from "cldr-numbers-full/main/en/currencies.json";
import numbersEn from "cldr-numbers-full/main/en/numbers.json";
import currenciesTr from "cldr-numbers-full/main/tr/currencies.json";
import numbersTr from "cldr-numbers-full/main/tr/numbers.json";

import i18next from "i18next";
import translationEN from "../src/i18n/en.json";
import translationTR from "../src/i18n/tr.json";
import "./config/languageInit";
import i18n from "./config/languageInit";
import { authorizationToken } from "./core/auth/helpers/authorizationToken";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./core/auth/helpers/authConfig";
import { MsalProvider } from "@azure/msal-react";
import { GraphService } from "./core/auth/services/GraphService";

load(
  likelySubtags,
  currencyData,
  weekData,
  caGregorian,
  dateFields,
  currenciesTr,
  timeZoneNamesTr,
  numbersTr,
  timeZoneNamesEn,
  currenciesEn,
  numbersEn,
);

loadMessages(translationEN, "en");
loadMessages(translationTR, "tr");

// Kendo UI license activation
setScriptKey(kendoLicense);

const jwtToken = localStorage.getItem("jwtToken");

if (jwtToken) {
  authorizationToken(jwtToken);
}
document.documentElement.lang = i18n.language;

// Synchronously apply the saved theme before React mounts to prevent
// a flash of the wrong theme. The useEffect in AppInner handles runtime changes.
const savedTheme = localStorage.getItem("theme") || "dark";
document.documentElement.setAttribute("data-theme", savedTheme);
const root = ReactDOM.createRoot(document.getElementById("root"));
axios.defaults.headers.common["Accept-Language"] = i18n.language;
// axios.defaults.baseURL = `${DAIKING_API}`;

export const msalApp = new PublicClientApplication(msalConfig);

msalApp.initialize().then(() => {
  if (!msalApp.getActiveAccount() && msalApp.getAllAccounts().length > 0) {
    msalApp.setActiveAccount(msalApp.getAllAccounts()[0]);
  }

  msalApp.enableAccountStorageEvents();
  GraphService.msalApp = msalApp;
  msalApp.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalApp.setActiveAccount(account);
    }

    if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      localStorage.setItem("aadToken", event.payload.accessToken);
    }
  });

  root.render(
    <LocalizationProvider language={i18next.language}>
      <IntlProvider locale={i18next.language}>
        <MsalProvider instance={msalApp}>
          <App />
        </MsalProvider>
      </IntlProvider>
    </LocalizationProvider>,
  );
});
